import { ReactElement, ReactNode } from 'react';
import { Box } from '@cbhq/cds-web/layout';
import { HStack } from '@cbhq/cds-web/layout/HStack';
import { TextHeadline } from '@cbhq/cds-web/typography';

import { ItemContainer } from './ItemContainer';

type ActionItemProps = {
  label: string;
  icon: ReactElement;
  onPress: () => void;
  end?: ReactNode;
  testID?: string;
};

export function ActionItem({ label, icon, end, onPress, testID }: ActionItemProps) {
  return (
    <ItemContainer handleOnClick={onPress} testID={testID} accessibilityLabel={label}>
      <HStack gap={2} justifyContent="space-between" width="100%" overflow="hidden">
        <HStack gap={2} alignItems="center">
          <Box width="32px" height="32px" justifyContent="center" alignItems="center">
            {icon}
          </Box>
          <TextHeadline as="p" color="fg" display="block">
            {label}
          </TextHeadline>
        </HStack>
        {end}
      </HStack>
    </ItemContainer>
  );
}
